import SuccessModal from '../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../components/modales/ErrorModal.jsx';
import { useResetPassword } from '../../hooks/auth/useResetPassword.js';

export default function ResetPassword() {
    const {
        password,
        confirmPassword,
        setPassword,
        setConfirmPassword,
        loading,
        handleSubmit,
        showErrorModal,
        errorMessage,
        closeErrorModal,
        showSuccessModal,
        successMessage,
        closeSuccessModal
    } = useResetPassword();

    return (
        <>
            <div className="container mt-5">
                <div className="text-center col-4 m-auto border rounded-3 p-4">
                    <h1 className="mb-4"><i className="bi bi-key-fill"></i></h1>
                    <h2 className="text-center mb-4">Restablecer Contraseña</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="input-group mb-3">                            
                            <input className="form-control" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Nueva contraseña" required />
                        </div>
                        <div className="input-group mb-3">                            
                            <input className="form-control" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirmar nueva contraseña" required />
                        </div>
                        <div className="form-group">                                                
                            <button className="btn btn-md btn-primary" type="submit" disabled={loading}>{loading ? 'Procesando...' : 'Restablecer Contraseña'}</button>
                        </div>
                    </form>
                </div>
            </div>

            <SuccessModal
                show={showSuccessModal}
                message={successMessage}
                onClose={closeSuccessModal}
            />
            
            <ErrorModal
                show={showErrorModal}
                message={errorMessage}
                onClose={closeErrorModal}
            />
        </>
    );
}